"use client";

import { ClockIcon } from "@radix-ui/react-icons";
import { Flex, Text } from "@radix-ui/themes";
import classNames from "classnames";
import React from "react";
import { Skeleton } from "@/app/components/ui/skeleton";
import { LiveCloseState, useLiveClose } from "./LiveCloseContext";

interface Props {
  loading?: boolean;
  className?: string;
}

const getLiveCloseTimeString = (liveCloseState: LiveCloseState | null) => {
  switch (liveCloseState) {
    case LiveCloseState.ACTIVE:
    case LiveCloseState.FAIR_WARNING:
      return "Live"
    case LiveCloseState.CLOSED:
    case LiveCloseState.READY_TO_ADVANCE:
    case LiveCloseState.FINISH_AUCTION:
      return "Closed"
    default:
      return "-"
  }
}

const LiveCloseTimer = (
  { loading = false, className }: Props
) => {
  const { liveCloseState } = useLiveClose();
  const timeLeftString = getLiveCloseTimeString(liveCloseState);

  return (
    <div className="relative inline-flex mb-4">
        <Flex
          justify="center"
          align="center"
          className={classNames(
            "relative z-60 border w-fit h-7 rounded-full",
            "bg-zinc-50/40 py-4 px-4",
            
            className
          )}
          gap="2"
        >
          {liveCloseState === LiveCloseState.FAIR_WARNING && <span
            aria-hidden="true"
            className={classNames(
              "pointer-events-none absolute inset-0 rounded-full",
            )}
          />}
          {loading || liveCloseState === null ? (
            <Skeleton className="w-20 h-full rounded-none" />
          ) : (
            <Flex align="center" className="space-x-2">
              <ClockIcon
                className="w-4 h-4"
                color={(liveCloseState === LiveCloseState.CLOSED || liveCloseState === LiveCloseState.READY_TO_ADVANCE) ? "red" : "black"}
              />
              <Text
                className={classNames(
                  "text-[14px] font-medium line-clamp-1",
                  (liveCloseState === LiveCloseState.CLOSED || liveCloseState === LiveCloseState.READY_TO_ADVANCE) ? "text-red-500" : ""
                )}
              >
                {timeLeftString}
              </Text>
            </Flex>
          )}
        </Flex>
    </div>
  );
};

export default LiveCloseTimer;
